/**
 * Created by neo on 30.11.2023
 */
import { makeAutoObservable } from 'mobx';

export type MapRegion = {
  latitude: number;
  longitude: number;
  latitudeDelta: number;
  longitudeDelta: number;
  toJS(): MapRegion;
};

export function createMapRegion(json?: Partial<MapRegion>): MapRegion {
  return makeAutoObservable({
    latitude: json?.latitude ?? 0,
    longitude: json?.longitude ?? 0,
    latitudeDelta: json?.latitudeDelta ?? 0,
    longitudeDelta: json?.longitudeDelta ?? 0,

    toJS(): MapRegion {
      return {
        latitude: this.latitude,
        longitude: this.longitude,
        latitudeDelta: this.latitudeDelta,
        longitudeDelta: this.longitudeDelta,
        toJS: this.toJS,
      };
    },
  });
}
